import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Header,
  HeaderBrand,
  HeaderWidgets,
  MainWrapper,
  PageContainer,
  Switch,
  ThemeWrapper,
  Themes,
  themeFlixDark,
} from '@flixbus/honeycomb-react';
import { Footer } from './Footer';
// Honeycomb-react helper classes
import '@flixbus/honeycomb-react/dist/css/honeycomb-helpers.css';
// imports Roboto font face and styles
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '../App.scss';

import WarningIcon from './Assets/WarningIcon';

function GlobalError() {
  const [theme, setTheme] = useState('flix' as Themes);
  const toggleTheme = () => {
    setTheme(theme === 'flix' ? 'flix-dark' : 'flix');
  };

  return (
    <>
      <ThemeWrapper theme={theme} themes={{ 'flix-dark': themeFlixDark }}>
        <MainWrapper full>
          <Header
            brand={
              <HeaderBrand
                appearance='square'
                alt='Honeycomb'
                href='/'
                src='https://honeycomb.flixbus.com/dist/7.0.0/img/logos/svg/honeycomb-white.svg'
              />
            }
            fixed
          >
            <HeaderBrand
              alt='Flixbus logo'
              src='https://honeycomb.flixbus.com/dist/7.2.13/img/logos/svg/flixbus-white.svg'
              href='/'
              RouterLink={Link}
            />
            <HeaderWidgets>
              <div className='theme-switcher-wrapper'>
                <Switch
                  id='theme-switcher-header'
                  extraClasses='theme-switcher'
                  small
                  label='Dark mode'
                  onChange={() => {
                    toggleTheme();
                  }}
                />
              </div>
            </HeaderWidgets>
          </Header>
          <PageContainer hasFixedHeader>
            <main
              className='main-container'
              style={{ textAlign: 'center', maxWidth: '500px', margin: 'auto' }}
            >
              <WarningIcon />
              <h2 style={{ display: 'block' }}>Sorry, something went wrong</h2>
              <span style={{ display: 'block', marginBottom: '18px' }}>
                It looks like your session has expired. Let&apos;s get you back on track!
              </span>
              <Button appearance='primary' size='md'>
                Go to Homepage
              </Button>
            </main>
          </PageContainer>
          <Footer />
        </MainWrapper>
      </ThemeWrapper>
    </>
  );
}

export default GlobalError;
